import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import WeddingForm from "../components/WeddingForm";
import { createWedding } from "../api/weddings";
import { CreateWeddingPayload } from "../types";
import { useAuth } from "../context/AuthContext";
import Loading from "../components/Loading";

const CreateWeddingPage: React.FC = () => {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (data: CreateWeddingPayload) => {
    setLoading(true);
    setError("");
    try {
      const { data: wedding } = await createWedding(data);
      navigate(`/weddings/${wedding.id}/edit`);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to create wedding");
    } finally {
      setLoading(false);
    }
  };

  if (authLoading) return <Loading />;

  if (!user) {
    return (
      <div className="page">
        <h1>Create Wedding</h1>
        <p className="form-hint">You must be signed in to create a wedding.</p>
        <Link to="/login" className="btn btn-primary">
          Sign In
        </Link>
      </div>
    );
  }

  return (
    <div className="page">
      <h1>Create Wedding</h1>
      <WeddingForm
        onSubmit={handleSubmit}
        loading={loading}
        submitError={error}
        onClearSubmitFeedback={() => setError("")}
      />
    </div>
  );
};

export default CreateWeddingPage;
